<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <!-- <a-col :span="24">
            <a-form-item label="医院名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-multi-select-tag type="checkbox" v-decorator="['hosName']" :trigger-change="true" dictCode="" placeholder="请选择医院名称"/>
            </a-form-item>
          </a-col> -->
          <a-col :span="24">
            <a-form-item label="科室名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['departmentName']" placeholder="请输入科室名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="科室照片" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <div style="text-align: left;">宽600px、高400px</div>
              <j-image-upload isMultiple v-decorator="['pic']" :maxWidth="'600px'" :maxHeight="'400px'"></j-image-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="科室简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-editor v-decorator="['introduction',{trigger:'input'}]" laceholder="请输入科室简介" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否特色科室" :labelCol="labelCol" :wrapperCol="wrapperCol">
               <a-select v-decorator="['isFeature']" placeholder="请选择是否特色科室" @change="isFeatureChange">
                <a-select-option :value="'Y'">是</a-select-option>
                <a-select-option :value="'N'">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-show="showFeatureTypeName">
            <a-form-item label="科室特色名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['featureTypeName']" placeholder="请输入科室特色名称"></a-input>
            </a-form-item>
          </a-col>
         <a-col :span="24"  v-show="showFeatureTypeName">
            <a-form-item label="科室特色照片" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <div style="text-align: left;">宽453px、高335px</div>
              <j-image-upload isMultiple v-decorator="['featurePic']" :maxWidth="'453px'" :maxHeight="'335px'"></j-image-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24"  v-show="showFeatureTypeName">
            <a-form-item label="科室特色简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
               <j-editor v-decorator="['featureIntroduction',{trigger:'input'}]" laceholder="请输入科室特色简介" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否项目服务" :labelCol="labelCol" :wrapperCol="wrapperCol">
               <a-select v-decorator="['isProduct']" placeholder="请选择是否项目服务" @change="isProductChange">
                <a-select-option :value="'Y'">是</a-select-option>
                <a-select-option :value="'N'">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-show="showProduct">
            <a-form-item label="项目服务照片" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <div style="text-align: left;">图片宽1400像素；高度自由调整（建议保持视觉协调，避免过高或过扁）</div>
              <j-image-upload isMultiple v-decorator="['productPic']" :maxWidth="'1400px'"></j-image-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-show="showProduct">
            <a-form-item label="项目服务简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
               <j-editor v-decorator="['productIntroduction',{trigger:'input'}]" laceholder="请输入项目服务简介" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="科室类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-decorator="['type']" placeholder="请选择科室类别" :getPopupContainer= "(target) => target.parentNode">
                <a-select-option :value="0">临床科室</a-select-option>
                <a-select-option :value="1">医技科室</a-select-option>
                <a-select-option :value="2">住院部科室</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['sort']" placeholder="请输入排序" style="width: 100%"/>
            </a-form-item>
          </a-col>
           <a-col :span="24">
            <a-form-item label="上架" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-switch v-decorator="['isUp']" ></j-switch>
            </a-form-item>
          </a-col>
          
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JMultiSelectTag from "@/components/dict/JMultiSelectTag"
  import JEditor from '@/components/jeecg/JEditor'
  import JSwitch from '@/components/jeecg/JSwitch'

  export default {
    name: 'WebsiteDepartmentForm',
    components: {
      JFormContainer,
      JImageUpload,
      JMultiSelectTag,
      JEditor,
      JSwitch,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/zyWebsite/websiteDepartment/add",
          edit: "/zyWebsite/websiteDepartment/edit",
          queryById: "/zyWebsite/websiteDepartment/queryById"
        },
        showFeatureTypeName:false,
        showProduct:false

      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      isFeatureChange(e){
         if(e === "Y"){
            this.showFeatureTypeName = true;
        }else{
            this.showFeatureTypeName = false;
        }
      },
      isProductChange(e){
         if(e === "Y"){
            this.showProduct = true;
        }else{
            this.showProduct = false;
        }
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.model.isFeature = 'N' 
        this.model.isProduct = 'N' 
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'hosId','hosName','departmentName','featureType','featureTypeName','isUp','isFeature','isProduct','productPic','productIntroduction','isUpLabel','pic','departmentId','introduction','type','sort','featurePic','featureIntroduction'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'hosId','hosName','departmentName','featureType','featureTypeName','isUp','isFeature','isProduct','productPic','productIntroduction','isUpLabel','pic','departmentId','introduction','type','sort','featurePic','featureIntroduction'))
      },
    }
  }
</script>